import { User } from '@auth0/auth0-react';

export type AuthMethod = 'auth0' | 'key' | null;

// 'checking' : vérification de la session en cours (au boot ou après un changement de méthode d'auth)
// 'valid'    : la session a été confirmée utilisable (token obtenu avec succès, ou auth par clé)
// 'invalid'  : pas de méthode d'auth, ou la vérification a échoué (session/SSO expirée)
export type SessionStatus = 'checking' | 'valid' | 'invalid';

export interface AuthContextType {
  authMethod: AuthMethod;
  keyToken: string | null;
  keyUser: User | null;
  isAuthenticated: boolean;
  sessionStatus: SessionStatus;
  authenticateWithKey: (token: string, user: User) => void;
  getAuthToken: () => Promise<string>;
  clearKeyAuth: () => void;
  isKeyAuthenticated: boolean;
}

export interface KeyAuthData {
  token: string;
  user: User;
  timestamp: number;
}

export class AuthenticationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthenticationError';
  }
}
